import { render, staticRenderFns } from "./CurrencyIcon.vue?vue&type=template&id=2e8db9c0&scoped=true&"
import script from "./CurrencyIcon.vue?vue&type=script&lang=js&"
export * from "./CurrencyIcon.vue?vue&type=script&lang=js&"
import style0 from "./CurrencyIcon.vue?vue&type=style&index=0&id=2e8db9c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8db9c0",
  null
  
)

export default component.exports